import PropTypes from 'prop-types';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Sidebar from 'components/Sidebar';
import FeaturedOffersList from 'components/Sidebar/FeaturedOffersList';

const StoresSidebar = ({ className, featuredOffers, ...rest }) => {
  const featuredOffersListRef = useRef(null);

  return (
    <Sidebar
      className={twMerge('hidden xl:flex', className)}
      refsToBeIgnoredBeforeFixing={[featuredOffersListRef]}
      {...rest}
    >
      <FeaturedOffersList
        ref={featuredOffersListRef}
        featuredOffers={featuredOffers}
      />
    </Sidebar>
  );
};

StoresSidebar.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  featuredOffers: PropTypes.arrayOf(
    PropTypes.shape({
      offerId: PropTypes.number.isRequired,
      offerTitle: PropTypes.string.isRequired,
      offerPrice: PropTypes.number.isRequired,
      offerOldPrice: PropTypes.number,
      offerPriceType: PropTypes.string.isRequired,
      offerPhoto: PropTypes.string.isRequired,
      offerSlug: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default StoresSidebar;
